<script setup>
import { ChevronRightIcon } from "@heroicons/vue/20/solid"
import { defineProps } from "vue"

const props = defineProps({
  pages: {
    required: true,
    type: Array,
  },
  divider: {
    required: false,
    type: String,
    default: "chevron",
  },
})
</script>

<template>
  <nav aria-label="Breadcrumb">
    <ol role="list" class="flex items-center space-x-4">
      <li v-for="(page, pageIdx) in pages" :key="pageIdx">
        <div class="flex items-center">
          <template v-if="pageIdx > 0">
            <ChevronRightIcon
              v-if="divider == 'chevron'"
              class="h-5 w-5 flex-shrink-0 text-gray-400"
              aria-hidden="true"
            />
            <svg
              v-else
              class="h-5 w-5 flex-shrink-0 text-gray-300"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
          </template>

          <router-link
            :to="page.to"
            :class="pageIdx > 0 ? 'ml-4' : ''"
            class="text-sm font-medium text-gray-500 hover:text-gray-700"
            :aria-current="page.current ? 'page' : undefined"
            >{{ page.name }}</router-link
          >
        </div>
      </li>
    </ol>
  </nav>
</template>
